import React from 'react';

import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './ViewExerciseSkeleton.styles';

export default function ViewExerciseSkeleton() {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <Box className={classes.wrapper} data-testid="view-exercise-skeleton">
      <Box className={classes.header}>
        <Skeleton variant="text" height={44} width="45%" />
        <Box className={classes.headerActions}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
      </Box>

      <Box className={classes.chipsRow}>
        <Skeleton variant="rounded" width={120} height={28} />
        <Skeleton variant="rounded" width={140} height={36} />
      </Box>

      <Box className={classes.imageBlock}>
        <Skeleton variant="rounded" width="100%" height={220} />
      </Box>

      <Box className={classes.contentGrid}>
        {Array.from({ length: 6 }, (_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            height={76}
            className={classes.card}
          />
        ))}
      </Box>

      <Skeleton variant="rounded" height={96} />
      <Skeleton variant="text" height={36} width="30%" />
      <Skeleton variant="rounded" height={56} width="50%" />
    </Box>
  );
}
